import TheNavigation from "@/components/app/nav/TheNavigation.vue";
import BrandLink from "./BrandLink.vue";
import ExportsDropdown from "./ExportsDropdown.vue";
import TheHeaderProfile from "./TheHeaderProfile.vue";
import { currentUser } from "@/core/users/session";
export default {
    computed: {
        user() {
            return currentUser();
        },
    },
    components: {
        BrandLink,
        ExportsDropdown,
        TheHeaderProfile,
        TheNavigation,
        // TheHeaderToolbar
    },
};
